import React, { useCallback, useRef, useMemo, useContext, } from 'react';
import classnames from 'classnames';
import throttle from 'lodash/throttle';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { useOnOutsideClick } from '@wix/da-hooks/pkg/useOnOutsideClick';
import NotificationIcon from '@wix/da-ds/pkg/Icons/24x24/Notification';
import { BiData } from '@wix/da-bi/pkg/events';
import IconButtonWithNotification from '@wix/da-ds/pkg/Buttons/IconButtonWithNotification';
import { NCContext } from '@wix/da-react-context/pkg/NCContext';
import { FirstTimeFlag } from '../../../redux/firstTimeFlags';
import SophisticatedFtueTooltip from '../../../Popover/Preset/SophisticatedFtueTooltip';
import { useNotificationDropdownHover } from '../useNotificationDropdownHover';
import s from './NotificationsDropdownWrapper.scss';
var NotificationsDropdownWrapper = function (_a) {
    var feedbackCount = _a.feedbackCount, className = _a.className, iconClassName = _a.iconClassName, numberClassName = _a.numberClassName, openNotificationsDropdown = _a.openNotificationsDropdown, closeNotificationsDropdown = _a.closeNotificationsDropdown, isLegacyHeader = _a.isLegacyHeader, isFeedbackPageOpen = _a.isFeedbackPageOpen, isNotificationsDropdownOpen = _a.isNotificationsDropdownOpen, toggleFeedbackPage = _a.toggleFeedbackPage, toggleBurgerMenu = _a.toggleBurgerMenu, ariaLabel = _a["aria-label"];
    var t = useTranslation().t;
    var _b = useContext(NCContext), DrawerComponent = _b.DrawerComponent, isStandalonePage = _b.isStandalonePage;
    var _c = useNotificationDropdownHover({
        isNotificationsDropdownOpen: isNotificationsDropdownOpen,
        openNotificationsDropdown: openNotificationsDropdown,
        closeNotificationsDropdown: closeNotificationsDropdown,
    }), handleNotificationsDropdownHover = _c.handleNotificationsDropdownHover, handleNotificationsDropdownLeave = _c.handleNotificationsDropdownLeave;
    var ftueEnabled = feedbackCount !== 0;
    // no point to spamming this if our guest has twitchy hands
    var throttledMouseLeave = useMemo(function () { return throttle(handleNotificationsDropdownLeave, 300); }, [handleNotificationsDropdownLeave]);
    var rootRef = useRef(null);
    var onClose = useCallback(function () {
        throttledMouseLeave();
    }, [throttledMouseLeave]);
    var handleClickOutside = useCallback(function () {
        if (!isNotificationsDropdownOpen) {
            return;
        }
        onClose();
    }, [isNotificationsDropdownOpen, onClose]);
    useOnOutsideClick(rootRef, handleClickOutside);
    var handleIconClick = useCallback(function (e) {
        if (isLegacyHeader) {
            window.location.assign(Url.feedbackLink());
            return;
        }
        if (!isStandalonePage) {
            toggleBurgerMenu(false); // Close network bar, if it's open
            toggleFeedbackPage();
        }
        // We put an `href` attribute on the element that calls this so users can open notifications in a new tab,
        // so we prevent default to avoid the standard handling of an anchor tag click since we're duper browsing.
        e.preventDefault();
    }, [isStandalonePage, isLegacyHeader, toggleFeedbackPage, toggleBurgerMenu]);
    return (React.createElement("div", { className: className, onMouseEnter: function () {
            if (!isFeedbackPageOpen && !isStandalonePage) {
                handleNotificationsDropdownHover();
            }
        }, onMouseLeave: function () { return handleNotificationsDropdownLeave(); }, ref: rootRef },
        React.createElement(SophisticatedFtueTooltip, { heading: t('siteHeader.notificationsMenu.ftue.heading'), description: t('siteHeader.notificationsMenu.ftue.description'), size: "medium", placement: "bottom", width: 301, flag: FirstTimeFlag.IsNewNCHeaderNotAcknowledged, hasCloseButton: true, enabled: ftueEnabled },
            React.createElement(React.Fragment, null,
                React.createElement(IconButtonWithNotification, { icon: NotificationIcon, size: "medium", notificationColor: "red", iconButtonClassName: iconClassName, numberClassName: numberClassName, count: feedbackCount, biData: BiData({
                        evid: 700,
                        link_name: 'notifications',
                        indicator: feedbackCount,
                    }), href: isStandalonePage || isFeedbackPageOpen
                        ? undefined
                        : Url.feedbackLink(), onClick: handleIconClick, "aria-label": t('siteHeader.a11y.cart.withItems', {
                        formattedCount: feedbackCount,
                    }) }))),
        DrawerComponent && !isStandalonePage && (React.createElement("div", { role: "dialog", id: "site-header-notifications", className: s['notifications-dropdown-wrapper'] },
            React.createElement("div", { className: classnames(s['container'], isNotificationsDropdownOpen && s['active']) }, isNotificationsDropdownOpen && (React.createElement(DrawerComponent, { isDropdown: true, openFeedbackPage: function () {
                    return toggleFeedbackPage && toggleFeedbackPage();
                } })))))));
};
NotificationsDropdownWrapper.displayName = 'NotificationsDropdownWrapper';
export default NotificationsDropdownWrapper;
//# sourceMappingURL=NotificationsDropdownWrapper.js.map